module.exports = __webpack_public_path__ + "static/media/leeching-worm.dd3f7bfe.svg";